import projection from '../generated/pwc5m4f1.json';
import { AcceptanceManifest } from '../types';

export const pwc5m4f1AcceptanceManifest = projection as AcceptanceManifest;
